import PageDefault, { ContentMenuItem } from "components/PageDefault";
import { useCallback, useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import actionService from "services/action.service";
import ActionData from "./ActionData";
import extractFormData from 'utils/extractFormatData';
import "./style.scss"
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import LoadPage from "components/LoadPage";
import flowService from "services/flow.service";
import { useUser } from "store/models";
import ActionStatus from "enums/ActionStatus";
import { useTranslation } from "react-i18next";
import { collect } from "utils/classes/collection";

export default function ActionForm() {
  const history = useHistory();
  const { state } = useLocation<any>();
  const [ backPath ] = useState(()=>{
    if(!!state && !!state.back_path){
      return state.back_path;
    }
    return "/action";
  })
  
  const user = useUser();
  const { params } = useRouteMatch<any>();
  const [data, setData] = useState<any>(() => {
    let d:any = {};
    if (!!params && !!params.id) {
      d.id = params.id;
    }
    return d;
  });
  const [loadPage, setLoadPage] = useState(true);
  const [errorPage, setErrorPage] = useState(false);
  const [steps, setSteps] = useState([]);

  const { t } = useTranslation()

  const edit = useCallback((property?:string) => {
    if (history.location.pathname.indexOf("create") !== -1) {
      return true;
    }
    if (history.location.pathname.indexOf("show") !== -1) {
      return false;
    }
    if (history.location.pathname.indexOf("edit") !== -1) {
      if(steps.length){
        if(data.action_status_id === ActionStatus.Rascunho){
          if(!collect(steps).where("from.id","=",ActionStatus.Rascunho).isEmpty()){
            return true
          }
        }
        if(data.action_status_id === ActionStatus.Reprovada){
          return true;
        }
        if(property && property === "description"){
          return true;
        }
        if(property && property === "files"){
          return true;
        }
        if(data.action_status_id === ActionStatus.EmProcessodePagamento){
          if(property && property === "pay_date") return true;
          if(property && property === "pay_observation") return true;
          if(property && property === "files") return true;
        }
      }
      return false;
    }
    return true;
  }, [history.location, steps, data.action_status_id])

  const loadData = useCallback(async () => {
    try {
      if(data.id){
        let d = await actionService.show(data.id, {
          params: {
            // fields:"id,firstname,lastname,email,profile_id",
            embed:"files:id"
          }
        });
  
        setData((old: any) => {
          return {
            ...old, ...d,
            files:d.files.map((f:any)=>f.id)
          }
        })
      }

      setLoadPage(false);
    } catch (error) {
      console.log(error);
      
      setErrorPage(true)
    }
  }, [setData, data.id]);

  useEffect(() => {
    loadData()
  }, [loadData]);

  useEffect(() => {
    if (data.action_status_id) {
      flowService.getStepsByStatus(data.action_status_id).then((data) => {
        setSteps(data)
      })
    }
  }, [data.action_status_id]);

  const submit = useCallback((status_id) => {
    // if(status_id === ActionStatus.Finalizada){
    //   let v = ReceivementValidator(data.receives)
    //   if(!v.passes()){
    //     for(let message of v.getErrors()){
    //       errorNotify(message);
    //     }
    //     return
    //   }
    // }

    let formdata = new FormData();
    // let dictionary = new Dictionary();
    extractFormData(data, formdata);
    // console.log(
    //   dictionary.getList()
    // );


    if (data.id) {
      formdata.append("action_status_id", status_id);
      actionService.updateLoad(data.id, formdata)
        .then(res => {
          history.push(backPath);
        })
        .catch(e => console.log(e))
    } else {
      formdata.append("action_status_id","1");
      actionService.storeLoad(formdata)
        .then(res => {
          history.push(backPath);
        })
        .catch(e => console.log(e))
    }
  }, [data, backPath, history]);

  const stepsButtons = useCallback(() => {
    function rules(list: any[]) {
      // if (data.action_status_id === ActionStatus.AguardandoDocumentos) {
      //   list = list.map(d => {
      //     if (d.to.id === ActionStatus.AguardandoRecebimento) {
      //       let aux = data.invoices;
      //       if (!Array.isArray(aux)) aux = Object.values(aux);
      //       let v = aux.reduce((soma: number, i: any) => {
      //         return soma + parseFloat(i.value);
      //       }, 0);
      //       d.disabled = v != data.value * data.quantity;
      //     }
      //     return d;
      //   })
      // }
      // if (data.action_status_id === ActionStatus.AguardandoRecebimento) {
      //   list = list.map(d => {
      //     if (d.to.id === ActionStatus.Finalizada) {
      //       d.disabled = !data.receive_id;
      //     }
      //     return d;
      //   })
      // }
      return list;
    }

    if (!data.id && history.location.pathname.indexOf("create") !== -1) {
      return [
        <Col xs="auto" key={1}>
          <Button size="sm" onClick={() => submit(0)}>Salvar</Button>
        </Col>
      ];
    }
    
    if (steps.length > 0 && history.location.pathname.indexOf("edit") !== -1) {
      let r = rules(steps.filter((s: any) => {
        return user.hasPermission(`action.index.update.change-status.${s.from.alias}.${s.to.alias}`)
      })).map((s: any, k: number) => {
        let options = s.options?JSON.parse(s.options):{name: s.to.name};
        return (
          <Col xs="auto" key={k}>
            <Button size="sm" onClick={() => submit(s.to.id)} disabled={s.disabled}>{options.name}</Button>
          </Col>
        )
      })
      return r;
    }
    return [];
  }, [data.id, steps, submit, user, history]);

  // function verifyStatus(status_id: number) {
  //   if (data.status) {
  //     return data.status.id === status_id
  //   }
  //   return false;
  // }

  if (loadPage) return (
    <LoadPage
      textLoad="Obtendo dados da ação"
      textError="Erro ao carregar dados da ação"
      error={errorPage}
    />
  );
  
  return (
    <PageDefault title={t("action:form:title")}>
      <PageDefault.Title>{t("action:form:title")}</PageDefault.Title>
      <PageDefault.ContentMenu>
        <ContentMenuItem
          component={ActionData} title={t("action:form:menu:data")}
          props={
            { model: data, setModel: setData, edit: edit }
          }
        />
        {/* <ContentMenuItem
          component={Invoice} title={t("action:form:menu:invoices")}
          props={
            { model: data, setModel: setData, edit: verifyStatus(ActionStatus.AguardandoDocumentos), limit: data.value * data.quantity, loadData }
          }
          danger={verifyStatus(ActionStatus.AguardandoDocumentos)}
          disabled={!data.id}
        />
        <ContentMenuItem 
          component={Receivement} title="Recebimento" 
          props={
            {model:data, setModel:setData, edit:verifyStatus(ActionStatus.AguardandoRecebimento)}
          }
          danger={verifyStatus(ActionStatus.AguardandoRecebimento)}
          disabled={!data.id}
        /> */}
      </PageDefault.ContentMenu>
      {stepsButtons().length > 0 ? (
        <PageDefault.Footer>
          <Row className="justify-content-between">
            <Col xs="auto">
              <Row className="justify-content-start">
                {stepsButtons()}
              </Row>
            </Col>  
          </Row>
        </PageDefault.Footer>
      ) : <></>}
    </PageDefault>
  )
}